module.exports = __webpack_public_path__ + "img/icon-empty-resource.7f0d0988.png";